import DeviceServiceClient from "../proto/generated/scavenger_grpc_web_pb";
import proto from "../proto/generated/scavenger_pb_formatted";
import { $auth } from "../main";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
let meta = {};
const tenant = ($auth && $auth.user[tenant_key] && $auth.user[tenant_key]["tenant"]) || "";

const token = localStorage.getItem("access_token");
if (token) {
  meta = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
    Tenant: tenant,
  };
}
// const options = {
//   keepCase: true,
//   longs: String,
//   enums: String,
//   defaults: true,
//   oneofs: true,
// };

// function getChannelCredentials() {
//   const rootCert = fs.FileReadStream(path.resolve(__dirname, '../certs/ca-crt.crt'));

//   // If you use CA root certificate
//   // const channelCredentials = ChannelCredentials.createSsl();

//   // If you use Self-Signed root certificate you need to provide it
//   const channelCredentials = grpc.GrpcWebClientBase.ChannelCredentials.createSsl(rootCert);

//   return channelCredentials;
// }

// const credentials = getChannelCredentials();
// const MobileService = new DeviceServiceClient.MobileServiceClient("https://grpc-container-1.azurewebsites.net", null);
const MobileService = new DeviceServiceClient.MobileServiceClient(process.env["VUE_APP_ROOT_API_GRPC"], null);

export const mobile_grpc_services = {
  GetSites() {
    return new Promise((resolve, reject) => {
      let params = new proto.Empty();
      MobileService.getSites(params, meta, (err, response) => {
        if (!err) {
          resolve(response.toObject().sitesDataList);
          // console.log(response.toObject());
        } else {
          reject(err);
        }
      });
    });
  },
};
